'use client';

import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { logout } from '@/lib/RTK/features/AuthSlice';
import { useRouter } from 'next/navigation';
import { staticURL } from '@/lib/servies/axiosConfig';
import LoginFormModal from './login-form-modal';
import { Button } from '../ui/button';
import { IoPersonSharp } from 'react-icons/io5';
import Link from 'next/link';

export default function BtnLogin() {
    const { token, name, accessRoute, panel } = useAppSelector(
        (s) => s.auth_token_slice,
    );
    const dispatch = useAppDispatch();
    const [isHydrated, setIsHydrated] = useState(false);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const router = useRouter();

    function handleLogout() {
        dispatch(logout());
        window.location.replace(window.location.href);
    }

    function handleContorlMatab() {
        router.push(`${staticURL}/checkRole?token=${token}&loc=doctor`);
    }
    function handleContorlAdmin() {
        router.push(`${staticURL}/checkRole?token=${token}`);
    }

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return null;
    }

    return (
        <div className="flex items-center justify-end flex-grow">
            {token && name ? (
                <>
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button
                                aria-label="ورود"
                                name="login"
                                onClick={() =>
                                    setProfileMenuOpen(!profileMenuOpen)
                                }
                                variant={'blueShaded'}
                                className="xl:!px-4 xs:!px-3 xs:!py-2 !py-1 !h-9 xs:!h-10 !px-1.5 !shadow-none !ring-0"
                            >
                                <IoPersonSharp className="text-xl" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="!ml-4 xl:!ml-0">
                            <div className="relative flex cursor-default !justify-end select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-gray-200 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 hover:bg-white">
                                {name ? name : 'نامشخص'}
                            </div>
                            {accessRoute === 1 && (
                                <DropdownMenuItem
                                    className="hover:bg-white"
                                    onClick={handleContorlMatab}
                                >
                                    پنل مدیریت مطب
                                </DropdownMenuItem>
                            )}
                            {panel === 1 && (
                                <DropdownMenuItem
                                    className="hover:bg-white"
                                    onClick={handleContorlAdmin}
                                >
                                    پنل ادمین
                                </DropdownMenuItem>
                            )}

                            <DropdownMenuItem className="hover:bg-white">
                                <Link
                                    href={'/user-panel'}
                                    className="w-full text-right"
                                >
                                    پنل کاربری
                                </Link>
                            </DropdownMenuItem>
                            <DropdownMenuItem
                                className="hover:bg-white"
                                onClick={handleLogout}
                            >
                                خروج از حساب
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </>
            ) : name === undefined ? (
                ''
            ) : (
                <LoginFormModal mainLogin />
            )}
        </div>
    );
}
